import React, { useMemo } from "react";
import { Link } from "../../Link";

import { UserRankings, putCommasIntoNumber, splitArray } from "@ecologi/shared";

import { getShieldIconUrl } from "../utils/get-shield-icon-url";
import { getBadgeIconUrl } from "../utils/get-badge-icon-url";
import { getLeaderboardStyles } from "../utils/get-leaderboard-styles";

type Props = {
  isTwoColumn?: boolean;
  pageTitle: string;
  title: string;
  userRankings: UserRankings[];
};

export const LeaderboardTable: React.FC<Props> = (props) => {
  const { isTwoColumn, userRankings, title, pageTitle } = props;

  // This component works for both single column and double
  // column components and this helper gets the appropriate styles
  const styles = useMemo(
    () => getLeaderboardStyles(isTwoColumn),
    [isTwoColumn]
  );

  userRankings.map(function (value, index, elements) {
    const curr = elements[index];
    const next = elements[index + 1];
    if (curr) {
      if (next && next.total === curr.total) {
        curr.tied = true;
        next.tied = true;
      }
    }
  });

  // const isSmallScreen = useMedia('(max-width: 500px)');
  const splitUserRankings = useMemo(
    () => splitArray(userRankings, userRankings.length / 2),
    [userRankings]
  );

  return (
    <article className={styles.table}>
      {splitUserRankings.map((sUserRankings: UserRankings[], idx: number) => (
        <div className={styles.col} key={idx}>
          {sUserRankings &&
            sUserRankings.map((user: UserRankings, userIdx: number) => {
              const {
                rank,
                tied,
                userId,
                groupName,
                fullName,
                username,
                total: trees,
                picture,
              } = user;

              const name = groupName || fullName || username;

              return (
                <Link
                  className={styles.row}
                  key={`${userId}-${userIdx}`}
                  href={`/${username}`}
                  title="View profile"
                >
                  {/*1st Group*/}
                  <div className={styles.rowGroup}>
                    <p className={styles.userRank}>
                      #{tied ? "T" : ""}
                      {rank}
                    </p>
                    {!isTwoColumn ? (
                      parseInt(picture) > -1 ? (
                        <img
                          alt={`Profile pic for ${name}`}
                          src={`/images/app/avatars/${picture}.png`}
                          className={styles.userProfile}
                        />
                      ) : (
                        <img
                          alt={`Profile pic for ${name}`}
                          src={picture}
                          className={styles.userProfile}
                        />
                      )
                    ) : null}
                    <p className={styles.userName} title={name}>
                      {name}
                    </p>
                  </div>

                  {/* 2nd Group*/}
                  <div className={styles.rowGroup}>
                    <p className={styles.userScores}>
                      {putCommasIntoNumber(trees)}
                    </p>
                    {!isTwoColumn && (
                      <div
                        style={{
                          backgroundImage: `url("${getShieldIconUrl(
                            pageTitle
                          )}")`,
                        }}
                        className={styles.shield}
                      ></div>
                    )}
                    {isTwoColumn && (
                      <div
                        style={{
                          backgroundImage: `url("${getBadgeIconUrl(
                            pageTitle
                          )}")`,
                        }}
                        className={styles.badge}
                      ></div>
                    )}
                  </div>
                </Link>
              );
            })}
        </div>
      ))}
      <span className={styles.title}>{title}</span>
    </article>
  );
};
